import { AuthManager } from "./AuthManager"

const products = [
  {
    name: "PgCTL",
    id: 1,
    type: "qualification",
    deliveryModes: ["self_paced", "live_instructor_led"],
  },
  {
    name: "PgCTL (Starter)",
    id: 1,
    type: "qualification",
    deliveryModes: ["independent"],
  },
  {
    name: "PgCTL (Professional)",
    id: 1,
    type: "qualification",
    deliveryModes: ["guided_self_paced"],
  },
  {
    name: "PgCTL (Executive)",
    id: 1,
    type: "qualification",
    deliveryModes: ["instructor_led"],
  },
  {
    name: "PgCTL (TDC)",
    id: 1,
    type: "qualification",
    deliveryModes: ["tdc"],
  },
  {
    name: "M.Ed",
    id: 5,
    type: "qualification",
    deliveryModes: ["live_instructor_led", "self_paced"],
  },
]

export const useProductFilterOptions = () => {
  const currentUser = AuthManager.getAuthInfo()?.user.email

  return products
    .map(product => ({
      label: product.name,
      value: product,
    }))
    .filter(p => {
      if (!currentUser) return false

      // Account for M.Ed demo
      if (currentUser === "monica.hart@demo.suraasa.com") {
        return p.label === "M.Ed"
      }

      return true
    })
}

export const getProduct = ({
  deliveryMode,
  id,
  type,
}: {
  deliveryMode: string
  id: number
  type: string
}) => {
  const product = products.find(
    product =>
      product.id === id &&
      product.type === type &&
      product.deliveryModes.includes(deliveryMode)
  )

  if (!product) {
    return null
  }

  return product
}
